// TODO: would actually probably want to extend dd menu that changes its contents on each open
// this was problematic with memory leaks ...  for now just creating separate one's for each ... this is the easiest way to go with the existing architecture

var DropDown = require('../../common/dropDown/dropDownContentView'),
    _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV'),
    PAGE_ACTION_ID = 'dd-page-actions';

module.exports = DropDown.extend({
    template: require('./menu-template.hbs'),
    templateOptions: function() {

        var pgModelIdentifier = this.model.typeIdentifier,
            vChannel = this.options.vChannel;

        return {
            id: PAGE_ACTION_ID + '-' + pgModelIdentifier + '-' + this.model.get('number'),

            isDownloadableAsPdf: vChannel.request('allowPageDownload', this.model, 1),
            isDownloadableRaw: vChannel.request('allowPageDownload', this.model),

            canBeLaunchedViaUrl: this.model.renderUrlViewForDocAndPageMode(),
            allowDelete: vChannel.request('allowDeletePages') // (could also get from page model but now centralized with delete multiple pages)

        };

    },
    onRender: function() {
        this.options.applyIframeShim && this._applyIframeShim();
    },
    ddOptions: function() {
        return {
            container: this.options.vChannel.request('getWrapper'),
            hPos: this.model.typeIdentifier === 'THUMB' ? 'left' : 'right'
        };
    },
    ui: {
        pageInfo:           '.pgInfo',
        launchPDF:          '.pop-page-pdf',
        dlOriginal:         '.dn-pg-raw',
        dlPDF:              '.dn-pg-pdf',
        launchUrl:          '.pop-url',
        deletePg:           '.delete-pg'
    },
    events: function() {

        var vCh = this.options.vChannel,
            m = this.options.model;

        return {
            'click @ui.pageInfo': function() {
                vCh.command('showPgInfo', m);
            },
            'click @ui.dlOriginal': function() {
                vCh.command('download', 'page', 'raw', m.get('pageNumber'));
            },
            'click @ui.dlPDF': function() {
                vCh.command('download', 'page', 'pdf', m.get('pageNumber'));
            },
            'click @ui.launchPDF': function() {
                vCh.command('openPageInNewWindowAsPDF', m);
            },
            'click @ui.launchUrl': function() {
                window.open( m.getPageUrl() );
            },
            'click @ui.deletePg': function() {
                vCh.command('showDeletePageDialog', m);
            }

        };
    },
    _applyIframeShim: function() {

        /*  not using iframeShim plugin b/c that only move with window repositioning, scroll
         *  this can move on panel resize, open/close etc, so make a shim that positions them with the actual element via DOM manip.
         *  for now this is custom: if there's a need for it again, make a generic jq plugin
         * */

        this.$iframeShimWr = this.$el
            .wrap('<div class="fixed-iframe-shim-wr">')
            .parent()
            .css({
                height:  this.$el.outerHeight(),
                width: this.$el.outerWidth(),
                position: 'absolute',
                top: this.$el.css('top'),
                right: this.$el.css('right'), //this is positioned right, not left for all types
                //if make generic jq plugin, make it top/left auto -- or just apply if they exist
                'z-index': parseInt( this.$el.css('z-index') ) + 1
            }).prepend(
                $('<iframe class="iframeShim" scrolling="no" frameborder="0">').css({ height:  '100%', width: '100%' })
            );

        this.$el.css({ top: 0, left: 0});

    },
    onBeforeDestroy: function() {
        //note: tested & confirmed the removal of the shim doesn't cause any more memory leaks than already exists via removal of the dropdown
        DropDown.prototype.onBeforeDestroy.apply(this, arguments);
        this.$iframeShimWr && this.$iframeShimWr.remove(); //do after (since it wraps, what is now dropdown, the old el)
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/pageActionDropdown/view.js
 ** module id = 430
 ** module chunks = 0
 **/